import { AxiosError, AxiosRequestConfig } from 'axios';
import { Gateway } from 'index';

import { ModuleWithComplete } from 'app/containers/AWPM-FWPM/Modules/models';

export const getModuleById = async (id: number, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get(`/modules/v1/modules/${id}`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getModules = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<ModuleWithComplete[]>(`/modules/v1/modules`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getModulesBySelectionForCourses = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<ModuleWithComplete[]>(`/modules/v1/modules/courses`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};

export const getDefaultModules = async (config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<ModuleWithComplete[]>(`/modules/v1/modules/default`, config);
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
